import type { Theme } from "@mui/material";

export default (theme: Theme) => {
  const responsiveField = {
    [theme.breakpoints.down("md")]: {
      width: "100%",
      maxWidth: "100%",
    },
  };

  return {
    page: {
      width: "800px",
      padding: 0,
      [theme.breakpoints.down("md")]: {
        width: "100%",
        height: "100%",
        borderRadius: 0,
        boxShadow: "none",
      },
    },

    item: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      [theme.breakpoints.down("md")]: {
        flexWrap: "wrap",
        padding: 0,
      },
    },

    actions: {
      gap: "1rem",
      justifyContent: "center",
    },

    divider: {
      margin: "1rem 0 1rem 7rem",
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },

    error: {
      marginLeft: "7rem",
      paddingLeft: "1rem",
      color: theme.palette.error.main,
      fontWeight: 500,
      [theme.breakpoints.down("md")]: {
        width: "100%",
        maxWidth: "100%",
        marginLeft: 0,
      },
    },

    saveChanges: {
      justifySelf: "center",
      marginTop: "1rem",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        marginLeft: 0,
        marginRight: 0,
      },
    },

    deleteAccount: {
      marginBottom: "0.5rem",
      ...responsiveField,
    },
  };
};
